import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function GuideSection() {
  const { t } = useTranslation();
  const steps = t("guide.steps", { returnObjects: true }) as unknown as string[];

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
          <div>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              {t("guide.title")}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              {t("guide.body")}
            </p>
            <ol className="mt-6 space-y-4">
              {steps.map((step, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-semibold text-background-50">
                    {i + 1}
                  </span>
                  <span className="pt-0.5 text-sm leading-relaxed text-foreground-700">
                    {step}
                  </span>
                </li>
              ))}
            </ol>
          </div>

          {/* Article entry card */}
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
              {t("article.categoryLabel")}
            </span>
            <h3 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
              {t("articleEntry.title")}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              {t("articleEntry.body")}
            </p>
            <Link
              to="/usfans-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              {t("articleEntry.button")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <p className="mt-4 text-xs text-foreground-400">{t("articleEntry.meta")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}